export const createCompanySlice = (set) => ({
    companies: {
        loading: false,
        data: [],
        single: {},
        selectedId: null
    },
    GET_COMPANIES_SUCCESS: (payload) => set(state => ({
        companies: {
            ...state.companies,
            data: payload,
            loading: false
        }
    })),
    GET_COMPANY_SUCESS: (payload) => set(state => ({
        companies: {
            ...state.companies,
            single: payload,
            loading: false
        }
    })),
    SELECT_COMPANY: (payload) => set(state => ({
        companies: {
            ...state.companies,
            selectedId: payload,
            single: {}
        }
    })),
});